import React from 'react';
import { Container, Nav, Navbar, Badge } from 'react-bootstrap';
import logo from '../Assets/logo.png';
import { Logout } from '@mui/icons-material';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import ContextHelper from '../ContextHooks/ContextHelper';
import Cookies from 'js-cookie';

function Header() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { setCurrentUser, currentUser } = ContextHelper();

  const handleLogout = () => {
    localStorage.clear();
    Cookies.remove('patient_token');
    setCurrentUser({});
    navigate('/');
  };

  const isAdmin = currentUser?.isadmin;
  const isSuperAdmin = currentUser?.type === 'superadmin';
  const isDoctor = currentUser?.type === 'Doctor';
  const isVerifier = currentUser?.type === 'verifier';

  // Safe parse permissions
  const permissions =
    typeof currentUser?.permissions === 'string' ? JSON.parse(currentUser.permissions) : currentUser?.permissions || {};

  const hasPermission = (permission) => permissions?.[permission] === 'true' || permissions?.[permission] === true;

  const NavLink = ({ to, label }) => (
    <Link to={to} className={`text-dark text-decoration-none fw-semibold fs-6 ${pathname === to ? 'active' : ''}`}>
      {label}
    </Link>
  );

  return (
    <Container fluid className="px-0">
      <Navbar expand="lg" className="bg-white border p-3">
        <Navbar.Brand href="/">
          <img src={logo} className="img-fluid" width={200} alt="logo" />
        </Navbar.Brand>
        <Navbar.Brand href="/">
          <Badge bg="" className="nav-badge-color">
            PACSDEV
          </Badge>
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto bg-white ps-4 ps-lg-0 gap-4">
            {pathname !== '/patient-report' && (
              <>
                {isAdmin || isVerifier ? (
                  <>
                    {/* Only Admin sees Add Report */}
                    {isAdmin && <NavLink to="/add-report" label="Add Report" />}

                    {isAdmin && !isVerifier ? (
                      !isSuperAdmin ? (
                        !isDoctor ? (
                          <NavLink to="/create-user" label="Add User" />
                        ) : (
                          <NavLink to="/update-doctor" label="Update Doctor" />
                        )
                      ) : (
                        <NavLink to="/users" label="Users" />
                      )
                    ) : null}
                    {hasPermission('add_verifier') && isAdmin && <NavLink to="/verifier" label="Add Verifier" />}

                    {/* Permission-based pages */}
                    {hasPermission('add_study') && <NavLink to="/add-new-study" label="Add Study" />}
                    {(hasPermission('turnaround_time') || isSuperAdmin) && (
                      <NavLink to="/turnaround-time" label="Turnaround Time" />
                    )}
                    {(hasPermission('business_revenue') || isSuperAdmin) && (
                      <NavLink to="/business-revenue" label="Business Revenue" />
                    )}

                    {isSuperAdmin && <NavLink to="/subscription-admin" label="Subscription" />}
                  </>
                ) : (
                  <>
                    {/* Normal Users */}
                    <NavLink to="/view-report" label="View Report" />
                    <NavLink to="/report-upload" label="Attachment" />
                    {hasPermission('patient_billing') && <NavLink to="/patient-billing" label="Patient Billing" />}
                    {hasPermission('patient_registration') && (
                      <NavLink to="/patient-registration" label="Patient Registration" />
                    )}
                    <NavLink to="/subscription-agent" label="Subscription" />
                  </>
                )}
              </>
            )}

            <div className="logout cursor-pointer text-lg-end" title="Logout" onClick={handleLogout}>
              <Logout />
            </div>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </Container>
  );
}

export default Header;
